import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=74f5c819&scoped=true&"
import script from "./scale.vue?vue&type=script&lang=js&"
export * from "./scale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f5c819",
  null
  
)

export default component.exports